import { AuthGuard } from '@auth/features/auth';
import { Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ErrorBoundary, Toaster } from '@/shared/ui';
import { onAppBootSuccess } from '@/shared/ui/error-boundary';
import css from './layout.module.scss';

// Strip the `_app_reload` bust query after a successful shell mount.
// Does NOT clear the auto-reload cooldown — clearing on boot re-armed
// infinite reloads during mid-deploy asset gaps (prod 2026-07-16).
const BootRecovery = () => {
  useEffect(() => {
    onAppBootSuccess();
  }, []);
  return null;
};

export const RootLayout = () => (
  <div className={css.root}>
    <ErrorBoundary>
      <BootRecovery />
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    </ErrorBoundary>
    <Toaster />
  </div>
);
